module.exports = __webpack_public_path__ + "img/mobile-topbar.39f12636.png";